<template>
  <div
    class="flex_box"
    :style="styleMerge"
  >
    <div class="current-active" />
    <div
      v-if="viewData.title"
      class="component-header"
    >
      <div
        class="component-title"
        :style="itemStyleMerge"
        :class="viewData.required ? 'required' : ''"
      >
        <div>{{ viewData.title }}</div>
        <div class="subtitle">
          {{ viewData.subtitle }}
        </div>
      </div>
      <div class="">
        <div class="three-dot" />
      </div>
    </div>
    <el-checkbox-group v-model="viewData.selectVal.defaultValue">
      <el-checkbox
        v-for="item in viewData.selectVal.addOptions"
        :key="item.value"
        :label="item.value"
      >
        {{ item.label }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>
<script>
import formMixin from '@/view/weappTmp/core/lib/package/comps-node-mixin.js'
export default {
  name: 'SpCheckbox',
  mixins: [formMixin],
  props: {},
  data () {
    return {
      viewData: {
        selectVal: {}
      }
    }
  },
  watch: {},
  created () {
    // console.log('SpCheckbox',this.viewData)
    console.log('SpCheckbox:this.props', this.props)
  },
  mounted () {
    // console.log('SpCheckbox-mounted',this.viewData)
  },
  methods: {}
}
</script>

<style scoped lang="scss">
@import '@/weappTmps/formTmps/index.scss';
.flex_box {
  // 纵向
  &_Vertical {
  }
  // 横向
  &_Horizontal {
    display: flex;
  }
}
</style>
